// Intended as item view for notification list dropdowns
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/notification-item-view.hbs';

var globalCh = Radio.channel('global');
var alertsCh = Radio.channel('alerts');
var apiCh = Radio.channel('api');

const Notification_item_view = Marionette.View.extend({
    template: Handlebars.compile(template),
    tagName: 'li',
    className: 'list-group-item notification-item',
    events: {
        'click a': 'mark_read_when_clicked',
    },
    on_success: function (e, success_message) {
        alertsCh.request('showAlert', { message: success_message, messageType: 'success' });
    },
    onRender: function () {
        var notifications = apiCh.request('notification');
        notifications.on('add change', this.updateBadge);
    },
    onAttach: function() {
        this.updateBadge();
    },
    templateContext: function () {
        let fa;
        let unread = !this.model.get('read');
        switch (this.model.get('priority')) {
            case 1:
                fa = 'times-circle';
                break;
            case 2:
                fa = 'exclamation-triangle';
                break;
            case 3:
                fa = 'info-circle';
                break;
            case 4:
                fa = 'info-circle';
                break;
            case 5:
                fa = 'info-circle';
                break;
            default:
                fa = 'info-circle';
        }
        return {
            fa,
            unread,
        };
    },
    updateBadge: function() { // sets the unread notifications to the html span element in notification-dropdown template
        const notifications = apiCh.request('notification');
        // Filter collections and count no. of unread messages filter[read] === false
        var unread_notification_count = notifications.filter(function(d){
            return d.attributes['read'] === false; 
        }).length;
        if (unread_notification_count > 0) {
            return $(".unread-noti").text(unread_notification_count); 
        }
    },
    mark_read_when_clicked: function() {
        this.model.collection.mark_read([this.model]);
        this.updateBadge();
        globalCh.request('show_notification_dialog', this.model);
    },
});

export default Notification_item_view;
